<template>
  <div class="me-2">
    <button class="btn btn-sm btn-flex btn-primary fw-bolder shadow-sm" :class="btnClass" style="border-radius: 8px;border-width: 0;border-style: none;"
            data-kt-menu-trigger="hover"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end">
      <i v-if="showIcon" class="fa fa-filter text-primary "></i>
      <span class="mx-4">{{ btnTitle }}</span>
      <i class="fa fa-angle-down text-white fs-2"></i>
    </button>
    <div id="filterDropdown" class="menu menu-sub menu-sub-dropdown menu-column w-150px" data-kt-menu="true">
      <div class="mh-250px hover-scroll-y" :class="{ 'py-2': !search }">
        <div v-for="(option, index) in filterOptions" :key="index" class="menu-item px-3 my-1">
          <span href="#" @click.prevent="toggleSelectedOption(option.value)"
                :class="{ 'bg-light-primary text-primary' : modelValue === option.value }"
                class="menu-link bg-hover-light-primary text-hover-primary px-3">
            {{ option.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue';

const props = defineProps({
  btnTitle: { type: String, required: true },
  search: { type: Boolean, default: true },
  options: { type: Array, default: () => [] },
  valueField: { type: String, default: 'id' },
  nameField: { type: String, default: 'name' },
  modelValue: String,
  showIcon: { type: Boolean, default: true },
  btnClass: { type: String, required: false },
});

const emits = defineEmits(['update:modelValue']);
const searchValue = ref('');

const valueFieldSelector = computed(() => props.valueField || 'id');
const nameFieldSelector = computed(() => props.nameField || 'name');

const formattedOptions = computed(() => {
  return props.options.map(option => {
    const name = option[nameFieldSelector.value];
    const value = option[valueFieldSelector.value];
    return {
      name,
      value,
    };
  });
});

const filterOptions = computed(() => {
  if (!props.search) return formattedOptions.value;
  if (!searchValue.value) return formattedOptions.value;
  return formattedOptions.value.filter(option =>
      option.name?.toString().toLowerCase().includes(searchValue.value.toLowerCase())
  );
});

const displayText = computed(() => props.modelValue ? filterOptions.value.find(el => el.value == props.modelValue)?.name  : props.btnTitle)

function toggleSelectedOption(selected) {
  emits('update:modelValue', selected);
}
</script>

<style scoped>
/* Add your styles here */
</style>
